export default __webpack_public_path__ + "static/media/img-6.cadfbc4a.jpg";